// extracted by mini-css-extract-plugin
export var header = "_sd-1";
export var maskBottom = "_sd-6";
export var maskMiddle = "_sd-7";
export var maskTop = "_sd-5";
export var root = "_sd-0";
export var scrollDownButton = "_sd-3";
export var scrollDownButtonHidden = "_sd-4";
export var viewport = "_sd-2";